// extracted by mini-css-extract-plugin
module.exports = {"card":"UserCard_card__2A5Tj","title":"UserCard_title__3BhB9","message":"UserCard_message__B2_kF","cta":"UserCard_cta__2ANKV"};